import React, {useRef, useState} from 'react';
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import CollectorForm from "../Component/Form";
import {Breadcrumbs, Btn, H5} from "../../../../../AbstractElements";
import SearchOptions from "../../../../CommonComponents/Search";
import CollectorTable from "../Component/CollectorTable";
import {Collector, CollectorTableRef} from "../../Types/CollectorTypes";

const CollectorIndex = () => {
    const [params, setParams] = useState<Record<string, unknown>>({});
    const [collectorModalVisibility, setCollectorModalVisibility] = useState(false);
    const [searchVisibility, setSearchVisibility] = useState<boolean>(false);
    const searchOptions = [{name: 'name'}, {name: 'contact', label: 'Mobile'}, {name: 'nic'}];
    const collectorTableRef = useRef<CollectorTableRef>(null);

    const collectorModalToggle = () => {
        setCollectorModalVisibility(!collectorModalVisibility);
    };

    const addCollector = (collector: Collector) => {
        if (collectorTableRef.current) {
            collectorTableRef.current.addCollector(collector);
        }
        collectorModalToggle();
    };

    const getCollectors = () => {
        if (collectorTableRef.current) {
            collectorTableRef.current.getCollectors();
        }
    };

    return (
        <div>
            <Breadcrumbs mainTitle="Collectors" parent="Application" title="Collectors"/>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Collectors</H5>
                                <div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setCollectorModalVisibility(true)
                                        }} type={'add'} permission={'create-collector'}/>
                                        <ButtonIcon attrBtn={{
                                            onClick: getCollectors
                                        }} type={'sync'} permission={'read-collector'}/>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setSearchVisibility(!searchVisibility)
                                        }} type={'search'} permission={'read-collector'}/>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {searchVisibility &&
                                    <SearchOptions callBack={(searchParams: Record<string, unknown>) => setParams(searchParams)}
                                                   searchOptions={searchOptions}/>}
                                <CollectorTable ref={collectorTableRef} params={params}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={collectorModalVisibility} toggle={collectorModalToggle} centered>
                <ModalHeader>
                    Create Collector
                </ModalHeader>
                <ModalBody>
                    <CollectorForm callBack={addCollector}/>
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{color: 'primary', onClick: collectorModalToggle}}>Close</Btn>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default CollectorIndex;
